import { ILogOutputService } from './Logger'
// import { appendFileSync } from 'fs'

class DebugLogService implements ILogOutputService {
    id: string = 'DevelopmentLogService'
    _folder = 'local_logs'
    _file = 'logs.txt'
    _path = this._folder + '/' + this._file

    init = (): Promise<void> => {
        return null
    }

    log = (text: string): Promise<void> => {
        try {
            console.log(text)
        } catch (error) {
            console.error('ERROR on log', error)
        } finally {
            return null
        }
    }

    info = (text: string): Promise<void> => {
        try {
            console.info(text)
        } catch (error) {
            console.error('ERROR on info', error)
        } finally {
            return null
        }
    }

    error = (error: Error): Promise<void> => {
        try {
            console.error(error)
        } catch (error) {
            console.error('ERROR on error', error)
        } finally {
            return null
        }
    }

    // _write = (text: string, level: 'LOG' | 'INFO' | 'ERROR', errName?: string, stackTrace?: string) => {
    //     if (!text || text.length === 0) return

    //     const date = '"' + new Date().toJSON() + '"'
    //     const sanitizedLevel = '"' + level + '"'
    //     const sanitizedText = '"' + text.replace(new RegExp('"', 'g'), '"') + '"'
    //     const sanitizedErrName = '"' + (errName ?? '') + '"'
    //     const sanitizedStack = '"' + (stackTrace ?? '') + '"'

    //     const line = [date, sanitizedLevel, sanitizedText, sanitizedErrName, sanitizedStack]
    //     const sanitizedLine = line.join(',') + '\r\n'

    //     appendFileSync(this._path, sanitizedLine)
    // }
}

const DebugLogger = new DebugLogService()
export default DebugLogger
